module.exports = __webpack_public_path__ + "static/media/pencil-paintbrush.8ff8ed1a.svg";